import { render, staticRenderFns } from "./ColumnTitle.vue?vue&type=template&id=78109012&scoped=true&"
import script from "./ColumnTitle.vue?vue&type=script&lang=js&"
export * from "./ColumnTitle.vue?vue&type=script&lang=js&"
import style0 from "./ColumnTitle.vue?vue&type=style&index=0&id=78109012&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78109012",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78109012')) {
      api.createRecord('78109012', component.options)
    } else {
      api.reload('78109012', component.options)
    }
    module.hot.accept("./ColumnTitle.vue?vue&type=template&id=78109012&scoped=true&", function () {
      api.rerender('78109012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/Table/ColumnTitle.vue"
export default component.exports